// extracted by mini-css-extract-plugin
export var chevron = "_jw-2";
export var dropdownItems = "_jw-0";
export var item = "_jw-1";